package com.dotdrives.web.pages.updates

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val updatesStyles = """
    .updates-page { min-height: calc(100vh - 118px); display: flex; flex-direction: column; }
    .updates-view-toggle { display: flex; padding: 3px; border-radius: 99px; background: #EFF1F4; width: fit-content; margin-bottom: 16px; }
    .updates-view-toggle-btn {
      padding: 6px 18px; border-radius: 99px; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 13px; font-weight: 800;
    }
    .updates-view-toggle-btn-active { color: #222D32; background: white; box-shadow: 0 1px 4px rgba(34,45,50,.12); }
    .updates-inline-banner { margin-bottom: 12px; }

    .updates-split { flex: 1; min-height: 0; display: flex; gap: 16px; }

    .updates-list-pane { width: 380px; flex: 0 0 auto; display: flex; flex-direction: column; background: #fff; border: 1px solid #E4E8EC; border-radius: 16px; overflow: hidden; }
    .updates-list-head { padding: 16px 18px; border-bottom: 1px solid #E4E8EC; }
    .updates-list-head-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; gap: 10px; }
    .updates-list-title { font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; }
    .updates-list-new-button { min-height: 34px; padding: 8px 14px; font-size: 12.5px; }
    .updates-filter-pills { display: flex; gap: 6px; flex-wrap: wrap; }
    .updates-filter-pill {
      border: 1.5px solid #D6DBE0; color: #5A6870; font-size: 11.5px; font-weight: 800;
      padding: 5px 12px; border-radius: 99px; cursor: pointer; background: white;
    }
    .updates-filter-pill-active { border-color: transparent; color: #fff; background: #222D32; }
    .updates-list-body { flex: 1; overflow: auto; padding: 10px 12px; }
    .updates-list-rows { display: flex; flex-direction: column; gap: 6px; }
    .updates-row {
      width: 100%; display: flex; gap: 11px; padding: 12px; border-radius: 12px; border: 1px solid #E4E8EC;
      background: white; cursor: pointer; text-align: left;
    }
    .updates-row:hover { border-color: #F26223; }
    .updates-row:focus-visible { outline: 2px solid var(--dot-focus); outline-offset: 2px; }
    .updates-row-selected { border-color: #F26223; background: #FEF8F6; }
    .updates-row-avatar {
      width: 36px; height: 36px; border-radius: 50%; display: flex; flex: 0 0 auto; align-items: center;
      justify-content: center; color: #fff; font-size: 12.5px; font-weight: 800;
    }
    .updates-row-copy { flex: 1; min-width: 0; }
    .updates-row-top { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; }
    .updates-row-title { font-weight: 800; font-size: 13.5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .updates-row-when { font-family: 'IBM Plex Mono', monospace; font-size: 10px; color: var(--dot-muted); flex: 0 0 auto; }
    .updates-row-preview { font-size: 12px; color: #5A6870; margin: 2px 0 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .updates-row-meta { display: flex; gap: 6px; align-items: center; }
    .updates-row-files { font-size: 10.5px; color: var(--dot-muted); }
    .updates-row-unread-dot { width: 8px; height: 8px; border-radius: 50%; background: #4696EC; margin-left: auto; flex: 0 0 auto; }
    .updates-list-skeleton { display: flex; flex-direction: column; gap: 8px; }
    .updates-list-empty-wrap { padding: 24px 8px; }

    .updates-thread-pane { flex: 1; min-width: 0; display: flex; flex-direction: column; background: #fff; border: 1px solid #E4E8EC; border-radius: 16px; overflow: hidden; }
    .updates-thread-head { background: #fff; border-bottom: 1px solid #E4E8EC; padding: 18px 24px; display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; }
    .updates-thread-title { font-family: 'Quicksand', sans-serif; font-size: 18px; font-weight: 700; }
    .updates-thread-subtitle { margin-top: 3px; font-size: 12px; color: var(--dot-muted); }
    .updates-thread-actions { display: flex; gap: 8px; flex: 0 0 auto; }
    .updates-thread-action {
      border: 1.5px solid #D6DBE0; color: #3D4A52; font-weight: 800; font-size: 12px;
      padding: 8px 14px; border-radius: 99px; cursor: pointer; background: white;
    }
    .updates-thread-action:disabled { opacity: .55; cursor: not-allowed; }
    .updates-thread-action-share { border-color: transparent; background: #00A65A; color: #fff; }
    .updates-thread-body { flex: 1; overflow: auto; padding: 20px 24px; }
    .updates-thread-messages { max-width: 680px; margin: 0 auto; display: flex; flex-direction: column; gap: 12px; }
    .updates-message { background: #fff; border: 1px solid #E4E8EC; border-radius: 14px; padding: 16px 18px; }
    .updates-message-head { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; }
    .updates-message-avatar {
      width: 30px; height: 30px; border-radius: 50%; display: flex; flex: 0 0 auto; align-items: center;
      justify-content: center; color: #fff; font-size: 11px; font-weight: 800;
    }
    .updates-message-author { font-weight: 800; font-size: 12.5px; }
    .updates-message-when { font-size: 10.5px; color: var(--dot-muted); }
    .updates-message-via-email { margin-left: auto; }
    .updates-message-body { font-size: 13.5px; color: #3D4A52; line-height: 1.6; white-space: pre-wrap; }
    .updates-composer { max-width: 680px; margin: 12px auto 0; background: #fff; border: 2px dashed #D6DBE0; border-radius: 14px; padding: 12px 14px; }
    .updates-composer-input {
      width: 100%; min-height: 60px; border: 0; outline: none; resize: vertical; font-size: 13.5px;
      color: #222D32; font-family: inherit; background: transparent;
    }
    .updates-composer-row { display: flex; justify-content: flex-end; margin-top: 8px; }
    .updates-thread-empty-wrap { padding: 40px 0; }

    .updates-dialog-backdrop {
      position: fixed; z-index: 40; inset: 0; display: flex; align-items: center; justify-content: center;
      padding: 24px; background: rgba(34,45,50,.34); animation: updates-fade-in 180ms ease both;
    }
    .updates-dialog { width: min(600px, 100%); max-height: calc(100vh - 48px); overflow: auto; padding: 26px 30px; border-radius: 20px; background: white; box-shadow: 0 24px 80px rgba(34,45,50,.25); animation: updates-pop-in 220ms ease both; }
    .updates-dialog-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
    .updates-dialog-title { font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; }
    .updates-dialog-close { color: var(--dot-muted); background: transparent; cursor: pointer; font-size: 16px; }
    .updates-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 12px; }
    .updates-form-field { display: grid; gap: 5px; }
    .updates-form-label { font-size: 12px; font-weight: 800; }
    .updates-form-select, .updates-form-textarea {
      border: 1px solid #E4E8EC; border-radius: 11px; padding: 10px 13px; font-size: 13px; color: #222D32;
      background: white; font-family: inherit; width: 100%;
    }
    .updates-form-textarea { min-height: 120px; resize: vertical; margin-bottom: 12px; }
    .updates-dialog-actions { display: flex; gap: 10px; margin-top: 6px; }
    .updates-dialog-actions > * { flex: 1; }

    .updates-share-recipients { display: flex; flex-direction: column; gap: 8px; margin-bottom: 14px; max-height: 260px; overflow: auto; }
    .updates-share-row {
      width: 100%; border: 1px solid #E4E8EC; border-radius: 12px; padding: 11px 14px; display: flex;
      align-items: center; gap: 10px; background: white; cursor: pointer; text-align: left;
    }
    .updates-share-row-selected { border: 2px solid #F26223; background: #FEF8F6; }
    .updates-share-row-copy { flex: 1; min-width: 0; font-weight: 800; font-size: 13px; }
    .updates-share-check { color: #F26223; font-weight: 900; }
    .updates-share-select-all { font-size: 12px; font-weight: 800; color: var(--dot-action-text); background: transparent; cursor: pointer; margin-bottom: 10px; }

    .reports-page { flex: 1; }
    .reports-kpis { display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:16px;margin-bottom:16px; }
    .reports-kpi-value { font-family:'Quicksand',sans-serif;font-size:27px;font-weight:700;margin:4px 0; }
    .reports-chart { margin-bottom:16px; }
    .reports-chart-data { margin-top:12px;border-collapse:collapse; }
    .reports-chart-data caption { text-align:left;color:var(--dot-muted);font-size:12px; }
    .reports-chart-data td { padding:6px 10px 6px 0;border-bottom:1px solid #EFF1F4; }
    .reports-chart-svg { width:100%;height:220px;margin-top:14px;border-left:1px solid #E4E8EC;border-bottom:1px solid #E4E8EC; }
    .reports-chart-legend { display:flex;gap:16px;justify-content:flex-end;font-size:12px;font-weight:700;color:#5F6C75; }
    .reports-chart-legend span::before { content:'';display:inline-block;width:14px;border-top:3px solid;margin-right:6px;vertical-align:middle; }
    .reports-chart-legend .actual::before { border-color:#F26223 }.reports-chart-legend .prior::before { border-color:#B4BCC2 }.reports-chart-legend .goal::before { border-color:#88949C;border-top-style:dashed }
    .reports-chart-axis { display:flex;justify-content:space-between;color:#88949C;font:10px 'IBM Plex Mono',monospace;margin:6px 0 10px; }
    .reports-chart-details summary { color:#B8491A;font-weight:800;font-size:12px;cursor:pointer;padding:6px 0; }
    .reports-filter-error { color:#A64114;font-weight:700;font-size:12px;margin:-10px 0 14px; }
    .reports-header { background: #fff; border: 1px solid #E4E8EC; border-radius: 16px; padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 18px; }
    .reports-title { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; }
    .reports-filters { display: flex; gap: 10px; align-items: center; }
    .reports-filter-select {
      border: 1.5px solid #D6DBE0; color: #5A6870; font-size: 12px; font-weight: 800; padding: 7px 14px;
      border-radius: 99px; background: white; cursor: pointer;
    }
    .reports-export-button { border: 1.5px solid #D6DBE0; color: #3D4A52; font-weight: 800; font-size: 12.5px; padding: 7px 15px; border-radius: 99px; cursor: pointer; background: white; }
    .reports-grid { display: grid; grid-template-columns: 1.3fr 1fr; gap: 16px; margin-bottom: 18px; }
    .reports-card { background: #fff; border: 1px solid #E4E8EC; border-radius: 16px; padding: 20px 24px; }
    .reports-card-title { font-family: 'Quicksand', sans-serif; font-size: 16px; font-weight: 700; margin-bottom: 16px; }
    .reports-target-bars { display: flex; flex-direction: column; gap: 13px; }
    .reports-target-row-head { display: flex; justify-content: space-between; font-size: 13px; margin-bottom: 5px; }
    .reports-target-name { font-weight: 800; }
    .reports-target-amt { font-family: 'IBM Plex Mono', monospace; color: #5A6870; }
    .reports-target-amt-goal { color: var(--dot-muted); }
    .reports-bar-track { height: 10px; background: #EFF1F4; border-radius: 5px; overflow: hidden; }
    .reports-bar-fill { height: 100%; border-radius: 5px; }
    .reports-side-stack { display: flex; flex-direction: column; gap: 16px; }
    .reports-budget-card { background: #222D32; color: #fff; border-radius: 16px; padding: 20px 24px; flex: 1; }
    .reports-budget-label { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: #8FA0AA; letter-spacing: 1px; margin-bottom: 6px; }
    .reports-budget-amount { font-family: 'Quicksand', sans-serif; font-size: 32px; font-weight: 700; }
    .reports-budget-goal { font-size: 16px; color: #8FA0AA; font-weight: 500; }
    .reports-budget-track { height: 8px; background: rgba(255,255,255,.12); border-radius: 4px; margin-top: 12px; overflow: hidden; }
    .reports-budget-fill { height: 100%; background: #F26223; border-radius: 4px; }
    .reports-leaderboard-card { background: #fff; border: 1px solid #E4E8EC; border-radius: 16px; padding: 18px 24px; }
    .reports-leaderboard-label { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted); letter-spacing: 1px; margin-bottom: 10px; }
    .reports-leaderboard-row { display: flex; align-items: center; gap: 10px; padding: 6px 0; }
    .reports-leaderboard-avatar { width: 26px; height: 26px; border-radius: 50%; display: flex; flex: 0 0 auto; align-items: center; justify-content: center; color: #fff; font-weight: 800; font-size: 10.5px; }
    .reports-leaderboard-name { font-weight: 800; font-size: 13px; flex: 1; }
    .reports-leaderboard-amt { font-family: 'IBM Plex Mono', monospace; font-size: 12.5px; color: var(--dot-positive); }
    .reports-monthly-table { display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; }
    .reports-monthly-head { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted); border-bottom: 2px solid #EFF1F4; padding-bottom: 8px; }
    .reports-monthly-row { display: contents; }
    .reports-monthly-cell { padding: 11px 0; border-bottom: 1px solid #F2F4F6; font-size: 13px; }
    .reports-monthly-month { font-weight: 800; }
    .reports-monthly-recurring { color: var(--dot-action-text); font-weight: 700; }
    .reports-monthly-total { text-align: right; font-family: 'IBM Plex Mono', monospace; font-weight: 500; color: var(--dot-positive); }
    .reports-restricted-wrap, .reports-empty-wrap, .reports-skeleton-wrap { padding: 24px 0; }

    @keyframes updates-fade-in { from { opacity: 0; } to { opacity: 1; } }
    @keyframes updates-pop-in { from { transform: translateY(14px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

    @media (max-width: 900px) {
      .updates-split { flex-direction: column; }
      .updates-list-pane { width: 100%; max-height: 320px; }
      .reports-grid { grid-template-columns: 1fr; }
      .reports-kpis { grid-template-columns:1fr 1fr; }
      .reports-monthly-table { font-size: 11px; }
    }
    @media(max-width:700px){.reports-kpis{grid-template-columns:1fr}.reports-header{padding:12px}.reports-filters{width:100%;flex-wrap:wrap}.reports-filter-select,.reports-export-button{flex:1 1 calc(50% - 8px)}.reports-card{padding:18px}.reports-monthly-table{min-width:680px}.reports-chart-axis span:nth-child(even){display:none}}
""".trimIndent()

val UpdatesStyles = FC<Props> {
    style { +updatesStyles }
}
